module.exports = __webpack_public_path__ + "static/media/portfolio3.9c59ee8c.jpg";